module.exports = __webpack_public_path__ + "static/waterproof-mattress-protector-1-thumbnail-c546f6c502ad45d82dbc38d7dcd02121.webp";